module.exports = __webpack_public_path__ + "img/228_btn2.dc7ac141.png";